import { useMemo } from "react";

import { useAppDispatch, useAppSelector } from "stores";
import { initUserSessionAction } from "stores/Auth";
import { loadAccessToken } from "utils";

type UserAppRole = "Admin" | "Employee";

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const {
    userProfileFetching,
    userProfileInitializing,
    status,
    userProfile,
    userAppRole,
    orgSelected,
  } = useAppSelector((state) => state.auth);

  const combinedPermissions = userProfile
    ? userProfile.permissions.join(" - ")
    : null;

  const checkPermission = (permission: string) => {
    if (!userProfile) return false;
    return userProfile.permissions.some((p) => p === permission);
  };

  const checkModule = (moduleCode: string) => {
    if (!userProfile || !combinedPermissions) return false;
    return combinedPermissions.includes(moduleCode);
  };

  const initUserSession = () => {
    const accessToken = loadAccessToken();
    if (!accessToken) return;
    dispatch(initUserSessionAction());
  };

  const isEmployee = useMemo(() => userAppRole === "Employee", [userAppRole]);

  const isLoggedIn = status === "AUTH";

  return {
    isInitializing: userProfileInitializing,
    data: userProfile,
    isLoggedIn,
    userProfile,
    userProfileInitializing,
    userProfileFetching,
    userAppRole: userAppRole as UserAppRole,
    organizations: userProfile?.organizations,
    orgSelected,
    apps: userProfile?.apps,
    isEmployee,
    checkModule,
    checkPermission,
    initUserSession,
  };
};
